<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import DRBtn from "@/components/UI/DRBtn.vue";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/**
 * Plan sans ouvrage : rien ne peut être créé ni classé tant qu'il n'est pas
 * rattaché. Même écran dans les onglets Observations et Parties.
 */

defineProps<{
  /** Hors ligne : le rattachement est impossible. */
  disabled?: boolean;
}>();

defineEmits<{
  (e: "link"): void;
}>();

const { t } = useTranslation();
</script>

<template>
  <div class="text-center py-4">
    <PhosphorIcon name="link-break" :size="32" class="text-grey" />
    <p class="text-grey mt-2 mb-3">
      {{ t("canvas:observations.notLinked.message") }}
    </p>
    <DRBtn
      icon="bi-link-45deg"
      :label="t('dashboard:drawings.linkDiagnostic.label')"
      variant="primary"
      size="sm"
      :disabled="disabled"
      @click="$emit('link')"
    />
  </div>
</template>
